import React from 'react';
import { Link } from 'react-router-dom';
import Picture from './components/Picture.jsx';
import {
  FaInstagram,
  FaYoutube,
  FaFacebookF,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope
} from 'react-icons/fa';

const socialLinks = [
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/gtechniqbr',
    icon: FaInstagram
  },
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/@gtechniqbrasil',
    icon: FaYoutube
  },
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/gtechniqbr',
    icon: FaFacebookF
  }
];

const contactDetails = [
  {
    label: 'WhatsApp',
    value: '+55 (61) 99254-3830',
    href: 'https://wa.me/5561992543830?text=Ol%C3%A1%2C%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20os%20produtos%20Gtechniq',
    icon: FaWhatsapp
  },
  {
    label: 'E-mail',
    value: 'contato@gtechniq.com.br',
    href: 'mailto:contato@gtechniq.com.br',
    icon: FaEnvelope
  }
];

const footerSections = [
  {
    title: 'Gtechniq Brasil',
    links: [      
      { label: 'Sobre Nós', to: '/sobre' },
      { label: 'Contato', to: '/contato' },
      {
        label: 'Rede Credenciada',
        to: '/encontre-um-profissional'
      },
      {
        label: 'Seja um Aplicador Oficial',
        to: '/seja-um-aplicador-oficial'
      }
    ]
  },
  {
    title: 'Gtechniq Global',
    links: [
      { label: 'Gtechniq UK', href: 'https://www.gtechniq.co.uk/' },
      {
        label: 'Notícias',
        href: 'https://www.gtechniq.co.uk/news/'
      }
    ]
  }
];

const footerLogoAlignment = 'self-center py-10';
const footerLogoOffset = 'var(--footer-logo-offset, 0)';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#f4f4f5] text-[#0000000]">
      <div className="px-0 py-0 sm:px-6">
        
        <div className="grid gap-12 items-stretch justify-items-stretch lg:grid-cols-2 lg:justify-items-start">
          
          <div className="w-full bg-[#ff0000] px-8 py-4 text-center text-white sm:-mx-6 sm:w-[calc(100%+3rem)] lg:w-full lg:self-stretch lg:text-left">
            <div className="flex flex-col items-center gap-4 overflow-visible lg:items-center">
              <Link
                to="/"
                className={`inline-flex w-fit ${footerLogoAlignment}`}
                style={{ marginInlineStart: footerLogoOffset }}
                aria-label="Gtechniq Brasil - Início"
              >
                <Picture src="/images/gtechniq-logo-white-letters.webp" alt="Gtechniq Brasil" className="h-[45px] w-auto filter-none dark:filter-none dark:invert-0 dark:brightness-100" style={{ filter: 'none', mixBlendMode: 'normal' }} />
              </Link>

              <div>

                <div className="mb-20 lg:-mt-4 max-sm:mb-6 max-md:mb-6 flex justify-center gap-4  sm:justify-start">
                  {socialLinks.map((social) => (
                    <a
                      key={social.name}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white transition hover:text-white"
                      aria-label={social.name}
                    >
                      <social.icon className="h-8 w-8" />
                    </a>
                  ))}
                </div>
              </div>
              <div className="hidden px-6 py-5 text-base font-medium uppercase tracking-[0.26em] text-white lg:flex lg:items-center lg:justify-between">
                <p className="tracking-normal text-[15px] normal-case font-bold">
                  &copy; {currentYear} Gtechniq Brasil. <span className=" font-medium text-[13px]"> Todos os direitos reservados.</span>
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-10 py-6">


            <div className="grid gap-10 text-center sm:grid-cols-2 sm:text-left xl:grid-cols-2">
              {footerSections.map((section) => (
                <div key={section.title}>
                  <h2 className="text-[22px] tracking-[0.03em] font-medium text-gray-900">{section.title}</h2>
                  <ul className="mt-5 space-y-3 text-sm text-[#2a2b2f]">
                    {section.links.map((link) => (
                      <li key={link.label}>
                        {link.to ? (
                          <Link
                            to={link.to}
                            className="text-[#303136] text-base tracking-[0.01em] transition hover:text-[#ff0000]"
                          >
                            {link.label}
                          </Link>
                        ) : (
                          <a
                            href={link.href}
                            className="text-[#303136] text-base tracking-[0.01em] transition hover:text-[#ff0000]"
                            target={link.href?.startsWith('http') ? '_blank' : undefined}
                            rel={link.href?.startsWith('http') ? 'noopener noreferrer' : undefined}
                          >
                            {link.label}
                          </a>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="grid gap-6 place-items-center text-center sm:grid-cols-2 sm:gap-12 sm:place-items-stretch sm:text-left xl:grid-cols-2">
              {contactDetails.map((contact) => (
                <a
                  key={contact.label}
                  href={contact.href}
                  className="group flex items-center justify-center gap-3 px-0 py-3 text-[#1f2023] text-center ring-black/5 transition hover:-translate-y-1 hover:shadow-md sm:justify-start sm:items-start sm:text-left sm:gap-4 sm:py-5"
                  target={contact.label === 'WhatsApp' ? '_blank' : undefined}
                  rel={contact.label === 'WhatsApp' ? 'noopener noreferrer' : undefined}
                >
                  <contact.icon className="h-5 w-5 shrink-0 text-[#ff0000] transition group-hover:scale-110 sm:mt-1" />
                  <div className="text-center sm:text-left">
                    <p className="text-[11px] uppercase tracking-[0.28em] text-[#6f7076]">{contact.label}</p>
                    <p className="mt-1  text-base font-semibold">{contact.value}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8 px-6 pb-6 text-center text-[#303136] lg:hidden">
        <p className="text-sm">
          &copy; {currentYear} Gtechniq Brasil. Todos os direitos reservados.
        </p>
      </div>


    </footer>
  );
};

export default Footer;
